<app-range-linechart
  [model]="data.model"
  [gebruikPerWeek]="data.totaal"
  *ngIf="!data.hidden"
></app-range-linechart>
